/**
 * @generated SignedSource<<a575e5185fc5c6fe98d7773a926de967>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProposalVotesSummaryVotesBarFragment$data = {
  readonly abstainVotes: {
    readonly amount: string;
  };
  readonly againstVotes: {
    readonly amount: string;
  };
  readonly forVotes: {
    readonly amount: string;
  };
  readonly " $fragmentType": "ProposalVotesSummaryVotesBarFragment";
};
export type ProposalVotesSummaryVotesBarFragment$key = {
  readonly " $data"?: ProposalVotesSummaryVotesBarFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProposalVotesSummaryVotesBarFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProposalVotesSummaryVotesBarFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TokenAmount",
      "kind": "LinkedField",
      "name": "forVotes",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TokenAmount",
      "kind": "LinkedField",
      "name": "againstVotes",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TokenAmount",
      "kind": "LinkedField",
      "name": "abstainVotes",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "OnChainProposal",
  "abstractKey": null
};
})();

(node as any).hash = "3953859abd4052043886a45319352935";

export default node;
